import { apiFetch } from './client';

export type CookieBannerText = { text: string };

/**
 * Fetches the public cookie-consent banner text for a tenant (alias or id) and language.
 * Anonymous; a missing/unknown tenant falls back to the platform default on the backend.
 */
export async function getCookieBannerText(tenant: string | null, lang: string): Promise<CookieBannerText> {
  const params = new URLSearchParams({ lang });
  if (tenant) params.set('tenant', tenant);
  return apiFetch<CookieBannerText>(`/v1/public/cookie-banner?${params.toString()}`);
}
